export default __webpack_public_path__ + "static/media/FPAY-MM  PR Announcement 2015 03 17_Final.404d92d3.pdf";